var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleClosecomponent = function SvgCircleClosecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.3 7C.3 3.313 3.292.333 6.996.333c3.703 0 6.697 2.98 6.697 6.667s-2.994 6.667-6.697 6.667C3.293 13.667.299 10.687.299 7ZM9.4 10.333l.944-.94L7.941 7l2.404-2.393-.944-.94L6.997 6.06 4.592 3.667l-.944.94L6.052 7 3.648 9.393l.944.94L6.997 7.94 9.4 10.333Z",
    fill: "current"
  })));
};
export default SvgCircleClosecomponent;